import {
  LOGIN,
  LOGOUT,
  SET_BACK_URL,
  REQUEST,
  REQUEST_SUCCESS,
  REQUEST_ERROR,
  LOCK_REQUESTS,
  UNLOCK_REQUESTS,
  SET_TOKEN,
  SET_TOKENS,
  REFRESH_TOKEN,
  CLEAR_SESSION,
} from "../types"

export function login({ login, password }) {
  return {
    type: LOGIN,
    login,
    password,
  }
}

export function setToken(token) {
  return {
    type: SET_TOKEN,
    token,
  }
}

export function setTokens(tokenType, token, refreshToken, expiresIn) {
  return {
    type: SET_TOKENS,
    tokenType,
    token,
    refreshToken,
    expiresIn,
  }
}

export function logout() {
  return {
    type: LOGOUT,
  }
}

export function clearSession() {
  return {
    type: CLEAR_SESSION,
  }
}

export function setBackUrl(url) {
  return {
    type: SET_BACK_URL,
    url,
  }
}

export function request(config) {
  return {
    type: REQUEST,
    config,
  }
}

export function requestSuccess(action, response) {
  return {
    type: REQUEST_SUCCESS,
    response,
    action,
  }
}

export function requestError(action, error) {
  return {
    type: REQUEST_ERROR,
    error,
    action,
  }
}

export function lockRequests() {
  return {
    type: LOCK_REQUESTS,
  }
}

export function unlockRequests() {
  return {
    type: UNLOCK_REQUESTS,
  }
}

export function refreshToken() {
  return {
    type: REFRESH_TOKEN,
  }
}
